import { useMemo, useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../../Components/Table/Table";
import { Button } from "../../Components/Button/Button";
import { Pagination, PaginationContent, PaginationItem, PaginationPrevious, PaginationLink, PaginationNext } from "../../Components/Pagination/Pagination";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { Input } from "../../Components/Input/Input";
// import * as SelectPrimitive from "@radix-ui/react-select";
import { useSelector } from 'react-redux';
import { Select } from '../../Components/Select/Select';
import { SelectTrigger } from '../../Components/Select/SelectTrigger';
import { SelectContent } from '../../Components/Select/SelectContent';
import { SelectItem } from '../../Components/Select/SelectItem';
// import { SelectSeparator } from '../../Components/Select/SelectSeparator';
// import { SelectLabel } from '../../Components/Select/SelectLabel';
import { SelectValue } from "../../Components/Select/SelectValue";
import { VideoModal } from '../../Components/VideoModal/VidepModal';
import { ThemeProvider } from '../../Context/ThemeContext/ThemeContext';
import Alert from "../../Components/Alert/Alert"
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { ClipLoader } from 'react-spinners';
import DistanceCalculator from '../../Components/DistanceCalculator/DistanceCalculator';

function EyeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function TrashIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18" />
      <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M10 6V3h4v3" />
    </svg>
  );
}

export function Videos() {
  // const { theme } = useTheme();
  const { darkMode } = useSelector((state) => state.darkMode);
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteObject, setDeleteObject] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState('All');

  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false); 

  const queryClient = useQueryClient();

  const resolveVideoUrl = (videoUrl) => {
    if (!videoUrl) return '';
    if (/^https?:\/\//i.test(videoUrl)) {
      return videoUrl;
    }

    const baseUrl = (process.env.REACT_APP_VIDEO_URL || '').replace(/\/+$/, '');
    const normalizedPath = String(videoUrl).replace(/^\/+/, '');
    return baseUrl ? `${baseUrl}/${normalizedPath}` : normalizedPath;
  };

  const columns = useMemo(
    () => [
      {
        id: 'uploadedBy',
        header: 'User',
        accessorKey: 'uploadedBy',
        cell: ({ row }) => {
          console.log("row", row)
          return (
            <div className="flex items-center gap-2 text-ellipsis overflow-hidden">
              <span>{row.original.uploadedBy}</span>
            </div>
          );
        },
      },
      {
        id: 'locationName',
        header: 'Place',
        accessorKey: 'locationName',
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-2 text-ellipsis overflow-hidden">
              <span>{row.original.locationName}</span>
            </div>
          );
        },
      },
      {
        id: 'videoUrl',
        header: 'Video URL',
        accessorKey: 'videoUrl',
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-2 w-[150px] text-ellipsis overflow-scroll overflow-y-hidden">
              <span>{row.original.videoUrl}</span>
            </div>
          );
        },
      },
      {
        id: 'likesCount',
        header: 'Likes',
        accessorKey: 'likesCount',
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-2">
              <span>{row.original.likesCount}</span>
            </div>
          );
        },
      },
      {
        id: 'uploadedAt',
        header: 'Uploaded At',
        accessorKey: 'uploadedAt',
        cell: ({ row }) => {
          return (
            <div className="flex items-center  gap-2 w-[150px] text-ellipsis overflow-hidden">
              <span>{row.original.uploadedAt}</span>
            </div>
          );
        },
      },
      {
        id: 'distance',
        header: 'Distance',
        accessorKey: 'distance',
        cell: ({ row }) => {
          const data = row.original?.distance;
      
          return (
            <div className="flex items-center gap-2 w-[150px] text-ellipsis overflow-hidden">
              {data ? (
                <DistanceCalculator targetCoordinates={data} />
              ) : (
                <span>No location data</span>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const handleView = (row) => {
    setSelectedVideo({
      ...row.original,
      videoUrl: resolveVideoUrl(row.original.videoUrl),
      frontVideoUrl: resolveVideoUrl(row.original.frontVideoUrl),
      rearVideoUrl: resolveVideoUrl(row.original.rearVideoUrl),
    });
    setIsModalOpen(true);
  };

  const handleDelete = (row) => {
    // console.log('Delete:', row.original);
    setDeleteObject(row.original)
    // console.log(darkMode);
    setAlertOpen(!alertOpen)
  };


  const deleteVideoMutation = useMutation({
    mutationFn: async (videoId) => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/video/delete-video`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ video: videoId }),
      });
      // if (response?.status == 401) {
      //   localStorage.removeItem("authToken");
      //   navigate(0)
      //   navigate("/login")
      // }
      // else if (response?.status == 400) {
      //   localStorage.removeItem("authToken");
      //   navigate(0)
      //   navigate("/login")
      // }
      // else if (response?.status == 500) {
      //   localStorage.removeItem("authToken");
      //   navigate(0)
      //   navigate("/login")
      // } else {
        // return response.json();
      // }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['videos', currentPage, itemsPerPage, filter]);
      setAlertOpen(false);
    },
    onError: (error) => {
      console.error('Error deleting video:', error.message.status);
    },
  });



  const deleteVideo = () => {
    // console.log("delete", deleteObject);

    if (deleteObject) {
      setIsDeleting(true);
      deleteVideoMutation.mutate(deleteObject._id);
      setIsDeleting(false);

    }
  }

  const { data, error, isLoading } = useQuery({
    queryKey: ['videos', currentPage, itemsPerPage, filter],
    queryFn: async () => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/video/all?page=${currentPage}&limit=${itemsPerPage}&filter=${filter}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response?.status == 401) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 400) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 500) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      } else {
        return response.json();
      }
    },
    keepPreviousData: true,
  });

  const tableData = useMemo(() => {
    console.log("user", data)
    if (data && data.success) {

      return data?.message?.videos?.docs.map(video => ({
        _id: video._id,
        uploadedBy: `${video?.user?.userName || video?.guestUser?.userName || 'Unknown'}${video.isAnonymous ? ' (anonymous RECC)' : ''}`,
        locationName: video.placeName,
        videoUrl: video.videoUrl,
        frontVideoUrl: video.frontVideoUrl,
        rearVideoUrl: video.rearVideoUrl,
        likesCount:video.likesCount,
        uploadedAt: moment(video?.uploadedAt).format("DD MMM YYYY, h:mm A"),
        distance:video?.location?.coordinates,
      }));
    }
    return [];
  }, [data]);

  // const totalPages = data?.message?.videos?.totalPages || 0;

  const totalEntries = data?.message?.videos?.totalDocs || 0;
  const totalPages = data?.message?.videos?.totalPages || 0;

  // Calculate the entries currently being shown
  const startEntry = (currentPage - 1) * itemsPerPage + 1;
  const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);

  const table = useReactTable({
    data: tableData,
    columns: useMemo(() => [
      ...columns,
      {
        id: 'actions',
        header: 'Actions',
        cell: ({ row }) => (
          <div className="flex items-center gap-2">
            <Button onClick={() => handleView(row)} variant="ghost" size="icon">
              <EyeIcon className="h-4 w-4" />
              <span className="sr-only">View</span>
            </Button>
            <Button onClick={() => handleDelete(row)} variant="ghost" size="icon" className="text-red-500">
              <TrashIcon className="h-4 w-4" />
              <span className="sr-only">Delete</span>
            </Button>
          </div>
        ),
      }
    ], [columns]),
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    globalFilterFn: 'includesString',
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-svh">
        <ClipLoader color="#000000" loading={true} size={50} /> 
      </div>
    );
  } 
  if (error) return <div>Error loading users: {error.message}</div>;

  const getPaginationRange = () => {
    const maxVisiblePages = 3;
    if (totalPages <= maxVisiblePages) {
      return [...Array(totalPages).keys()].map(i => i + 1);
    }
    const startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    const adjustedStartPage = Math.max(endPage - maxVisiblePages + 1, 1);
    const adjustedEndPage = Math.min(adjustedStartPage + maxVisiblePages - 1, totalPages);
    return [...Array(adjustedEndPage - adjustedStartPage + 1).keys()].map(i => i + adjustedStartPage);
  };

  const paginationRange = getPaginationRange();

  return (
    <ThemeProvider>
      <div className="border rounded-lg m-2">
        <div className="flex justify-between items-center m-2">
          <Input
            type="search"
            placeholder="Search videos..."
            value={globalFilter ?? ''}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full max-w-sm"
          />
           <div className={`w-full max-w-sm ${darkMode ? 'dark' : ""}`}>
            <Select onValueChange={setFilter} className="w-full">
              <SelectTrigger className="placeholder" placeholder="Select an option">
                <SelectValue value={filter} />
              </SelectTrigger>
              <div>
                <SelectContent className={`${darkMode ? 'dark' : ""}`}>
                  <SelectItem value='All'>All</SelectItem>
                  <SelectItem value='7 Days'>7 Days</SelectItem>
                  <SelectItem value='24 Hours'>24 Hours</SelectItem>
                </SelectContent>
              </div>
            </Select>
          </div>
          <div className={`w-full max-w-sm ${darkMode ? 'dark' : ""}`}>
            <Select onValueChange={setItemsPerPage} className="w-full">
              <SelectTrigger className="placeholder" placeholder="Select an option">
                <SelectValue value={itemsPerPage} />
              </SelectTrigger>
              <div>
                <SelectContent className={`${darkMode ? 'dark' : ""}`}>
                  <SelectItem value={10}>10</SelectItem>
                  <SelectItem value={15}>15</SelectItem>
                  <SelectItem value={20}>20</SelectItem>
                  <SelectItem value={25}>25</SelectItem>
                </SelectContent>
              </div>
            </Select>
          </div>
        </div>
        <Table>
          <TableHeader>
            <TableRow>
              {table.getHeaderGroups().map(headerGroup =>
                headerGroup.headers.map(header => (
                  <TableHead key={header.id}>
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          onClick: header.column.getToggleSortingHandler(),
                          style: { cursor: 'pointer' },
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: ' 🔼',
                          desc: ' 🔽',
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </TableHead>
                ))
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows.map((row) => (
              <TableRow key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className="border-t h-15 p-4 items-center flex justify-between  ">
          <div>
            <span className='text-sm text-muted-foreground dark:text-gray-200'>  Showing {startEntry} to {endEntry} of {totalEntries} entries </span>
          </div>

          <div>
            <Pagination>
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  />
                </PaginationItem>
                {paginationRange.map((page) => (
                  <PaginationItem key={page}>
                    <PaginationLink
                      onClick={() => {
                        if (page <= totalPages) {
                          setCurrentPage(page);
                        }
                      }}
                      isActive={currentPage === page}
                    >
                      {page}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                <PaginationItem>
                  <PaginationNext
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </div>

        </div>
        <VideoModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          video={selectedVideo}
          darkMode={darkMode}
        />
        <Alert
          open={alertOpen}
          onOpenChange={setAlertOpen}
          title="Delete Video"
          description="Are you sure you want to delete this video?"
          type="delete"
          onConfirm={deleteVideo}
        />

      </div>
    </ThemeProvider>
  );
}
